import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import ArchiveTeamPhoto from './ArchiveTeamPhoto'

class ArchivePhotoGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      archiveData: props.archiveData,
      country: props.country,
      year: props.year,
      isFetching: props.isFetching,
      photoPath: props.photoPath
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      archiveData: nextProps.archiveData,
      country: nextProps.country,
      year: nextProps.year,
      isFetching: nextProps.isFetching
    })
  }
  team(country) {
    if (!this.state.isFetching && this.state.archiveData) {
      return this.state.archiveData.filter(location => {
        return location.country === country
      })[0]
    } else {
      return { members: [] }
    }
  }
  render() {
    console.log(this.state)
    let teamData = this.team(this.state.country)
    let photoPath = this.state.photoPath

    return (
      <div className='archive-photo-grid group'>
        {
          teamData.members.map(function(member) {
            return <ArchiveTeamPhoto photoPath={photoPath} key={member.id} member={member} />
          })
        }
      </div>
    )
  }
}
ArchivePhotoGrid.contextTypes = {
}
ArchivePhotoGrid.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchivePhotoGrid)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchivePhotoGrid.js